import { UiSchema, RJSFSchema } from '@rjsf/utils';
import React from 'react';
import { CaseCreationStaticSchema } from 'src/components/Forms/CreateCase/CreateCaseSchema';

export interface DDMAttributes {
  createCaseStaticSchema?: CaseCreationStaticSchema; //renders the static content from this schema.
  createCaseUiSchema?: UiSchema; //the UI schema for the Dynamic Schema.
  createCaseSchema: RJSFSchema; //the main schema
  formData?: any;
  caseSummarySchema?: RJSFSchema;
  caseSummaryUiSchema?: UiSchema;
  caseSummaryFormData?: any;
  ddmSchemaId?: string;
  ddmSchemaVersion?: string;
}

export const defaultValue: DDMAttributes = {
  createCaseSchema: {},
};

export const DDMAttributeContext =
  React.createContext<DDMAttributes>(defaultValue);

export const DDMAttributesProvider = ({
  children,
  formData,
  createCaseStaticSchema,
  createCaseUiSchema,
  createCaseSchema,
  caseSummarySchema,
  caseSummaryUiSchema,
  caseSummaryFormData,
  ddmSchemaId,
  ddmSchemaVersion,
}) => {
  return (
    <DDMAttributeContext.Provider
      value={{
        formData,
        createCaseStaticSchema,
        createCaseUiSchema,
        createCaseSchema,
        caseSummarySchema,
        caseSummaryUiSchema,
        caseSummaryFormData,
        ddmSchemaId,
        ddmSchemaVersion,
      }}
    >
      {children}
    </DDMAttributeContext.Provider>
  );
};

export default DDMAttributesProvider;
